/** Alinhado a server/src/constants/operationalUsers.ts — carteira Sophia */
export const OPERATIONAL_BDR_USER_ID = '67f99674-ca85-4c59-b05c-0298fa10fbe6'

export const HYBRID_BDR_CLOSER_USER_IDS: readonly string[] = [OPERATIONAL_BDR_USER_ID]

export function isHybridBdrCloser(userId: string | undefined | null): boolean {
  if (!userId) return false
  return HYBRID_BDR_CLOSER_USER_IDS.includes(userId)
}
